"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmountBlock = exports.InfoBlock = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Types_1 = require("Types");
exports.InfoBlock = styled_components_1.default.div `
  display: flex;
  ${props => props.variantType === Types_1.VariantTypes.CAROUSEL_VIEW && `flex-direction: column; align-items: center; width: 100%;`}

  ${props => props.variantType === Types_1.VariantTypes.SEARCH_VIEW && `flex-direction: column;`}

  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    ${props => props.variantType === Types_1.VariantTypes.FULL_VIEW &&
    `
      flex-direction: column;
      align-items: center;
    `}
  }
`;
exports.AmountBlock = styled_components_1.default.div `
  display: flex;
  ${props => props.variantType === Types_1.VariantTypes.MINI_CART_VIEW && `flex-direction: column;`}
  ${props => props.variantType === Types_1.VariantTypes.CAROUSEL_VIEW && `justify-content: space-between;`}
  > button {
    white-space: nowrap;
    margin-left: ${props => props.theme.spacing.s4}px;
    padding: ${props => props.theme.spacing.s3}px ${props => props.theme.spacing.m1}px;

    @media (max-width: ${props => props.theme.breakpoints.md}px) {
      ${props => props.variantType === Types_1.VariantTypes.FULL_VIEW &&
    `
      width: ${props.theme.constants.addToCart.buttonWidth}px;
    `}
    }
  }
`;
exports.default = {
    InfoBlock: exports.InfoBlock,
    AmountBlock: exports.AmountBlock
};
